
import { Options, prop, Vue } from "vue-class-component";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import Icons from "@/app/ui/components/icons/index.vue";

export interface PickupDetailSummaryCardMetrics {
  koliCount?: number;
  weightKg?: number;
  sttCount?: number;
  pickupDateLabel?: string;
  pickupTimeLabel?: string;
  additionalKoli?: number;
}

class Props {
  totalRequest = prop<PickupDetailSummaryCardMetrics>({
    type: Object,
    required: true
  });
  totalPickup = prop<PickupDetailSummaryCardMetrics>({
    type: Object,
    required: true
  });
  agentHub = prop<PickupDetailSummaryCardMetrics>({
    type: Object,
    required: true
  });
  loading = prop<boolean>({
    type: Boolean,
    default: false
  });
}

@Options({
  components: {
    Skeleton,
    Icons
  }
})
export default class PickupDetailSummaryRow extends Vue.with(Props) {
  get totalRequestKoli(): number {
    return this.totalRequest.koliCount || 0;
  }

  get totalRequestWeight(): number {
    return this.totalRequest.weightKg || 0;
  }

  get totalRequestSchedule(): string {
    return this.getSchedule(this.totalRequest);
  }

  get showTotalRequestAdditionalKoli(): boolean {
    return (this.totalRequest.additionalKoli || 0) > 0;
  }

  get totalPickupStt(): number {
    return this.totalPickup.sttCount || 0;
  }

  get totalPickupKoli(): number {
    return this.totalPickup.koliCount || 0;
  }

  get totalPickupWeight(): number {
    return this.totalPickup.weightKg || 0;
  }

  get totalPickupSchedule(): string {
    return this.totalPickup.pickupDateLabel || "";
  }

  get showTotalPickupAdditionalKoli(): boolean {
    return (this.totalPickup.additionalKoli || 0) > 0;
  }

  get agentHubStt(): number {
    return this.agentHub.sttCount || 0;
  }

  get agentHubKoli(): number {
    return this.agentHub.koliCount || 0;
  }

  get agentHubWeight(): number {
    return this.agentHub.weightKg || 0;
  }

  get agentHubSchedule(): string {
    return this.getSchedule(this.agentHub);
  }

  get showAgentHubAdditionalKoli(): boolean {
    return (this.agentHub.additionalKoli || 0) > 0;
  }

  getSchedule(metrics: PickupDetailSummaryCardMetrics): string {
    return [metrics.pickupDateLabel, metrics.pickupTimeLabel]
      .filter(Boolean)
      .join(", ");
  }
}
